import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useTimeError = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const goToReservationDate = () => {
    //ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate('/reservation-date');
  };

  const goToReservationTime = () => {
    //ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate('/reservation-time');
  };

  const handleSubmit = async (values, on) => {
    setLoading(true);
    setError(null);
    try {
      await on(values);
    } catch (err) {
      setError('Invalid Reservation. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
    goToReservationTime,
    goToReservationDate,
  };
};
